<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <p>
        <a data-v-9f21bbfe="">第一章 总则</a><br /><a data-v-9f21bbfe=""
          >一、概述</a
        ><br />为规范美滋来信息发布行为，营造合法、和谐的平台经营环境，维护消费者的权益，根据国家法律法规，以及《平台商户入驻服务框架协议》、平台管理规范等，制定本规范。<br />美滋来仅对商户上传的信息进行形式审查，不承担任何保证义务，因商户上传的信息违反本规范或造成任何法律后果的，由发布该信息的商户承担全部法律责任并赔偿美滋来及其关联公司因此遭受的全部经济及名誉损失（包括但不限于工商投诉、行政处罚、违约、侵权等各类纠纷导致的损失），美滋来保留对商户进行处理并直至停止平台服务的权利。<br />商户在美滋来发布信息应当遵守本规范。商户同意美滋来有权对商户上传的信息进行审核、整理、修改、复制、传播。任何违反本规范而发布的信息，美滋来有权立即删除且不承担任何责任。商户不得重复上传被删除的信息。<br /><a
          data-v-9f21bbfe=""
          >二、适用范围</a
        ><br />1.
        本管理规范适用于在美滋来发布包括但不限于商品信息的所有商户。<br />2.
        本管理规范适用于所有美滋来内部运营部门及城市工作人员。<br /><a
          data-v-9f21bbfe=""
          >三、相关释义</a
        ><br />1.
        品类：依据消费者需求和消费者购买行为将商品按照相同特征进行分类。<br />2.
        敏感词：一般是指带有敏感政治倾向、暴力倾向、不健康色彩的词或不文明用语，也会根据自身平台实际情况，设定一些不适用于本平台的特殊敏感词。<br />3.
        禁售商品：美滋来不允许发布的商品，包括国家法律法规禁止出售的商品（包括违规商品描述），以及美滋来禁止出售的商品。<br />4.
        申诉：对已处理的商品、已封口的敏感词、商户惩处不认可的可进行申诉。<br />5.
        封口：等同于“屏蔽”，强行限制商户录入相关商品信息。<br />6.
        解封：商户可恢复录入。<br />7.
        咨询：指对未处理的商品、敏感词及相关规则条例可进行咨询。<br />8.
        美滋来（以下简称“平台/美滋来”）：指为商户提供商品/服务展示及交易信息的网络服务平台，包括但不限于美滋来小程序、美滋来商家客户端、美滋来用户客户端、美滋来关联方平台及/或客户端等。<br />9.
        商户：指在美滋来开展经营活动并向用户提供商品、服务的法人、自然人或其他组织。<br />10.
        商品：指商户通过美滋来与用户进行交易的所有合法产品和服务。为避免歧义，本规范中所称商品包含服务。<br /><a
          data-v-9f21bbfe=""
          >四、基本要求</a
        ><br />1.
        商户不得发布任何违反法律、法规及违背公序良俗的信息，包括但不限于危害国家统一、主权和领土完整、泄露国家秘密、破坏民族团结、宣扬邪教、迷信、色情、暴力、赌博或教唆犯罪、危害社会公德等。<br />2.
        商户不得发布含有任何侵害他人姓名权、肖像权、隐私权、商标权、著作权或其他合法权益的信息，不上传任何带有贬损或损害性特征的内容，如未授权的复制品；未正式发行的名录，隐私资料，商业内部数据等。<br />3.
        商户不得发布带有病毒或引导别人下载计算机病毒的信息。<br />4.
        商户不得发布禁售商品的信息，并且发布的商品品类不得超出与美滋来签订协议的约定范围或违反美滋来发布的其他规范/规则/管理办法等。<br />5.
        商户的任何发布内容中（包括但不限于标题、广告语、图片、水印等）不得出现非美滋来的其他平台标识、信息或链接及其他复制、抄袭等可能涉及侵犯第三方合法权益的内容。<br />6.
        商户不得发布不符合国家规定的强制性质量标准或者安全标准的商品。<br />7.
        商户不得发布未取得国家规定的生产经营许可或销售许可的商品。<br />8.
        商户不得发布未经报关或虽经报关但没有完整报关材料的进口商品，亦不得出售没有中文标签的商品。<br />9.
        商户不得发布经监管部门或媒体曝光存在质量问题的商品。<br />10.
        商户不得出售假冒商品，假冒商品包括但不限于商家出售的商品假冒他人注册商标、出售盗版商品，或商家出售商品的材质、成份信息的描述与消费者收到的商品完全不符。<br />11.
        商户不得扰乱市场秩序，扰乱市场秩序包括但不限于商家扰乱和破坏公平竞争、平等交易的市场秩序，侵害其他商家权益或对平台造成不良影响的行为。<br />12.
        商户不得夸大商品宣传，在发布内容中出现违反国家广告法的宣传描述。<br />13.
        商户不得发布任何对消费者诋毁、恐吓、威胁的内容。<br />14.
        商户不得发布任何引导消费者线下交易或转向其他平台交易的内容。<br />15.
        商户发布的商品，若属于品牌商品，需具备商标注册人给予给商户的真实有效的商标授权书或其他真实有效使用证明。<br />16.
        商户需做好商品检测报告等重要资质及其他店铺入驻资质的申请和备案，做好商品的标识标志、质量的检查工作，使之符合法律、法规及行业标准的要求，美滋来将会进行不定期抽检，详情可参见《商户经营行为抽查监测规范》。<br /><a
          data-v-9f21bbfe=""
          >第二章 信息管理规范</a
        ><br /><br /><a data-v-9f21bbfe="">一、合规规范</a><br />1.
        经营品类管理<br />美滋来商户可经营下表所列商品品类，根据主营商品选择正确品类，并应确认发布的商品品类在营业执照及许可证的范围内。<br />一级品类二级品类美食快餐小吃、香锅/烤鱼、海鲜/烧烤、火锅、特色菜、东南亚菜、地方菜、西餐、日韩料理甜点饮品甜品、冻酸奶／炒酸奶、水果捞、中西糕点、面包/小蛋糕、生日蛋糕、冰淇淋、咖啡、奶茶果汁、冰淇淋、咖啡、奶茶果汁、凉茶/龟苓膏、其他饮品食材肉禽店、菜市场、火锅专营、海鲜/水产店、综合生鲜果蔬超市水果整装水果店、鲜切水果/果捞店鲜花绿植鲜花店、绿植/园艺店、综合鲜花绿植店超市便利大型超市/卖场、小型超市、便利店食品专营酒水饮料店、零食/干果店、地方特产店、进口食品商店/超市、粮油调味店、茶行、水站、奶站
        <br />2. 信息发布要素<br />2.1商品名称：名称应具有简洁性，指向唯一，可通过名称判断食材，烹饪方法，口味等属性信息。<br />2.2
        分类名称：名称中需体现同一类商品具有共同属性的一类名称。例如凉菜，主食，饮品等。<br />2.3
        商品描述：文字应包含与菜品相关的描述信息，可从色、香、味、口感等多维度描述。<br />2.4
        规格：是体现菜品的体积，大小，重量的重要指标。例如大份、中份、小份。<br />2.5
        属性：可体现菜品的温度、辣度、口味等信息。例如重辣、中辣、微辣。<br />2.6
        单位：商品的计量单位。例如份、个。<br />2.7
        商品标签：用于商品个性化展示及商品性质定位。<br />2.8
        价格：商品应明码标价，确保可以提供任一价格的合法依据或可供比较的出处，在美滋来标注的价格不得高于门店售卖价格，不可虚构原价，不得哄抬价格，亦不得违反《价格法》等价格相关法律法规其他规定。<br />2.9
        商户名称：指有实体经营场所的商户称谓。<br />2.10
        商户公告：用于店铺或菜品的介绍、推荐及注意事项等内容。<br />2.11
        商品图片：用于展示商品信息的手段。<br />2.12
        商品视频：用于商户通过视频或动图展示菜品信息。<br />3. 信息发布规范<br />3.1商品发布规范<br />3.1.1
        商户名称须符合《美滋来商家名称命名规范》要求。<br />3.1.2
        商品名称、分类名称、描述、属性、规格、商户公告可由中文、维文、英文、数字组成；单位、商品标签可用中文、维文、英文组成；价格只能由数字组成。<br />3.1.3
        套餐类商品命名规范：xxx套餐（菜品1+菜品2+菜品3）。<br />3.1.4
        商品名称禁止如下情形：<br />A、包含促销类活动信息，包括但不限于赠饮，折扣，满减等信息；<br />B、商品名称中不得带有欺诈或者诱惑消费者的词语；<br />C、商品命名中不得擅自使用他人注册商标描述产品。<br />3.1.5
        商品名称与描述禁止含有表示夸张、功能效、治疗类、安全性的断言或者保证。<br />3.1.6
        商品发布的内容包括但不限于商品名称、图片、商品描述等，须与实际经营的商品相符，并不得与用户收到的商品或经美滋来定期或不定期抽检的商品存在差异。且商户应当对商品瑕疵、保质期、生产日期、附带品等必须说明的信息进行披露。<br />3.1.7商品须为真实有效商品，禁止带有其他平台字样信息及非商品类信息展示，包括但不限于：微信，支付宝，红包，公众号，二维码、加群、广告，招聘、宣传语等。<br />3.1.8
        禁止出现法律法规禁售及平台禁售的商品。详见“4.”平台商品禁售类型<br />3.1.9
        商品宣传发布内容不得违反《中华人民共和国广告法》、《互联网广告管理暂行办法》、《食品广告发布暂行规定》等广告宣传相关管理法律法规。<br />3.1.10
        其他违背社会公共利益或公共道德、国家相关法律法规/政策或依据美滋来与商户间协议和美滋来发布的其他规范/规则/管理办法等不得发布的商品，禁止在美滋来发布。<br />3.2
        图片发布规范<br />3.2.1
        菜品图需清晰、完整（容器拍摄完整）、色彩鲜明有食欲、方向正确。&nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br />3.2.2
        菜品图片不得打马赛克，不得有水印及其他品牌logo（商户水印/logo除外），包括但不限于：美团外卖、百度外卖、饿了么、微信、微博、二维码等。<br />3.2.3
        菜品图片比例为4：3，分辨率不得低于600*450，大小不超过5M。<br />3.2.4
        菜品信息必须与图片相符。&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br />3.2.5
        菜品图不得拍摄菜单、宣传彩页等，不得含有截图的信息（如鼠标标识，下一页提示，iPhone的屏幕home键等）。<br />3.2.6
        必须为商户的售卖商品，不得为商户的展示类信息，包括但不限于环境图、门脸图、营业执照、二维码、广告、招聘、红包、微信群等宣传信息。&nbsp;
        &nbsp; &nbsp;<br />3.2.7
        菜品图不得出现除菜品餐具及品牌元素外任何描述性文字，如价格信息等。<br />3.2.8
        菜品图不得出现其他平台图片。<br />3.2.9
        菜品图必须保持干净整洁，菜品摆放整齐，背景不能出现杂物。<br />3.2.10
        菜品图片不得出现涉毒、涉暴、涉黄等违反法律法规、政策或监管部门要求或平台规定的敏感图片。<br />3.2.11
        菜品图不得为动态图片。<br />
        <a data-v-9f21bbfe="">二、违规处罚</a><br />1. 违规类型级别及说明<br />依据《平台禁售商品类型》内容将违规级别划分为以下两类，以下处罚准则均依据违规级别和具体禁售类型进行惩处。禁止商户以任何方式规避平台图片、文字识别等技术手段上传违法违规商品，一经发现平台将门店直接下线或永久下线不合作。<br /><strong
          >违规级别平台禁售类型说明处罚准则</strong
        >严重违规一、易燃易爆，有毒化学品、毒品类<br />二、仿真枪、军警用品、危险武器类<br />三、色情低俗、催情用品类<br />四、反动等破坏信息类<br />五、人身安全、隐私类<br />六、违反国家行政法规<br />七、动植物、器官及工具类<br />八、药品、医疗器械类<br />九、平台实物类※
        售卖的商品及商品信息严重危害到了国家、公共、人身安全，并出售国家/地方法律明令禁止售卖的商品和违反其他国家规定的商品，同时给平台造成了重大的负面影响。<br />如易燃易爆物品、毒品及带有危险的化学成分；枪支弹药；涉黄的信息；涉黄信息与违规药品；涉政类信息；人体器官；侵害个人隐私；宣扬反动、歧视等不良信息等。1、置休<br />2、永久下线不合作一般违规一、引导其他平台信息/图片<br />二、较为敏感的信息/图片<br />三、超范围经营类<br />四、非商品信息类<br />五、其他类※
        一定程度上不会造成身心安全、健康等严重危害，对平台造成了一定的不良影响。<br />如引流、商品图片/文本带有较为敏感的信息；平台不合作品类；超范围经营的商品；非商品信息展示；以及虚拟商品等。1、警告&amp;删除<br />2、置休<br />3、下线2.
        处罚细则<br />2.1 违规商品属于同级别违规，按以下标准执行：<br /><strong
          >违规级别商家违规次数处罚形式涉及商品数/个处罚时长</strong
        >严重违规1警告&amp;删除&amp;置休/3天2删除&amp;置休/7天3永久下线不合作//一般违规1警告&amp;删除≥1/2置休1-21h置休&gt;2商品个数-1h3下线1-21天下线&gt;2商品个数-1天2.2
        违规商品属于不同级别违规，按最高违规级别标准执行<br />2.3
        说明：①以上处罚日期以明细下发第二个工作日开始执行；②以上监控均是累计计算。<br /><a
          data-v-9f21bbfe=""
          >三、申诉</a
        ><br />1. 申诉说明<br />1.1
        平台依据法律和管理规范删除商品或置休、下线门店后，如商户有异议的，可依据平台提示或咨询业务经理询问具体原因；<br />1.2
        针对美滋来对商户的违规处理措施，如商户认为不合理的，则有权依据本规范或其他相关规范在收到违规处理之日起，在美滋来指定申诉时间内向美滋来外卖提起违规申诉，如商户在指定申诉时间内未进行违规申诉的，视为商户认可违规处罚。<br />1.3
        为了保证申诉的有效性，提高申诉成功率，商户申诉时需按照美滋来的要求提供完整、真实、有效的证明材料，包括但不限于：聊天记录、截图、链接、照片、录音、快递单凭证、报案回执等。如商户提供虚假证明材料的，即视为申诉不成功。<br />1.4
        美滋来在收到商户提起申诉后，将及时审核商户提交的申诉材料并反馈相应处理结果。若违规申诉成功，则对应的违规处罚不成立、处罚措施不执行；若申诉不成功，则对应的违规处罚成立、处罚措施将直接执行。<br />1.5
        申诉内容需按格式反馈，以便平台对接人查询相关内容，谢谢配合！<br />1.6
        申诉前请先自行判断商品可参考“平台禁售类型”、敏感词判断是否必须使用该词语、商户惩处可参考“违规级别及说明”。<br />2.
        申诉内容<br />2.1 已处理的商品<br /><strong
          >申诉日期申诉类型业务经理商家ID商家名称商品名称</strong
        ><br /><strong>（需填写完整无误）申诉理由商品删除时间申诉结果</strong
        ><br /><strong>（由平台填写）</strong
        >2023/x/x商品xxxxxxxxxx2019/x/x撤销/告知违规原因2.2 已封口的敏感词<br /><strong
          >申诉日期申诉类型需求方业务经理涉及敏感词涉及商品申诉理由仲裁申诉结果（由平台填写）</strong
        >2023/x/x敏感词商超/城市等xxXxxxxx解封/告知未解封原因2.3
        商家惩处结果不认可<br /><strong
          >申诉日期申诉类型业务经理商家ID商家名称违规级别申诉理由申诉结果</strong
        ><br /><strong>（由平台填写）</strong
        >2023/x/x商家惩处xxxxxx严重/一般/严重&amp;一般请说明具体商品重新界定结果/维持原处罚备注：<br />1.
        申诉时间：鉴于商户惩处存在时效性，申诉时间可在商户惩处明细下发当天进行申诉。<br />2.
        申诉结果：维持原判会告知判断标准及违规缘由。<br /><a data-v-9f21bbfe=""
          >四、相关内容咨询</a
        ><br />业务经理可联系平台对接人对“未处理”商品、敏感词等相关内容进行咨询。<br /><a
          data-v-9f21bbfe=""
          >第三章 敏感信息管理规范</a
        ><br /><a data-v-9f21bbfe="">一、目标与要求</a
        ><br />美滋来致力于搭建平等、绿色、便捷、多样化的外卖平台。<br />为了合理规范美滋来的敏感信息及违规商品，总部平台部门搭建敏感信息管理规范用来闭环管理商品及平台信息。<br /><a
          data-v-9f21bbfe=""
          >二、管理职责</a
        ><br />美滋来平台重视外卖敏感信息的管理，专人负责敏感信息的收集、排查、应用、反馈、同步、保密等工作。<br /><a
          data-v-9f21bbfe=""
          >三、管理流程</a
        ><br />1. 入口把控<br />&nbsp;&nbsp;敏感信息有三个入口来源，分别为舆情监控、人工收集、第三方数据外采，而这三种信息来源的把控对象均是文本和图片。审核手段利用内部审核把控，将文本和图片通过人工审核判断信息的准确性，筛选出敏感词，绝不允许各类敏感词和图片信息在平台的发布。<br />2.
        产品实现<br />&nbsp;&nbsp;从入口-操作-反馈-信息同步每一个流程都用有形产品串联起来才得以实现闭环管理，从产品决策阶段-设计阶段-试制阶段-定型阶段-持续改进阶段是一个循序渐进、逐步完善的过程，特殊的是这些阶段会有交叉、重叠、循环，而划分阶段的意义就在于形成工作流，能够让复杂的工作有据可依，有理可循并尽可能少的出错，让每一个产品功能的实现都成为敏感信息库化运作的管理手段。<br />3.
        流程监控<br />敏感信息的监控伴随管理过程的活跃期全程存在，平台并行两种监控维度，一是外部监控，是指整个外卖平台存在的敏感信息及违规商品都属于平台监控范畴，利用技术、惩处、宣导、反馈等多种手段做到闭环式监控管理；二是内部监控，是指平台内部对敏感词的研判或各业务方的反馈、平台内部人员的工作进度分析及结果研究，是平台内部健康发展的重要手段。在实施整个管理规范过程中，要随时进行跟踪监控，以便进行适当的资源调配和进度调整，以使整个流程能够按计划规定的进度及相应的指标顺利完成，并提供现阶段工作的反馈信息，以利于后续阶段的顺利开展和整个流程的闭环管理。<br />4.
        改进机制<br />敏感信息管理规范中改进机制的重点环节在反馈线上，分别从申诉、投诉、新增监控及回访三个维度获取有效信息用来校验整个流程存在的未闭环阶段。通过这三个维度的信息反馈，平台会从内外部综合进行校验。针对存在的风险和问题，责任部门对出现的问题进行分析，确定产生问题的根本原因以及带来的影响，相关负责人需要制定改进措施，包含临时措施和永久措施，确认执行后定期验证纠正情况，并将此次问题归纳总结以便流程优化。<br /><a
          data-v-9f21bbfe=""
          >第四章 管理体系建设与发展</a
        ><br />如今，互联网发展迅速，网民人数成倍增长，各种行业、年龄和阶层的人都参与到互联网中，论坛、博客、微博等网络平台已成为个人和群体表达诉求的有效工具，更成为境内外别有用心的人破坏社会和谐、污蔑党委政府、颠覆政权的途径。再加上有些不明真相的网民转载跟风，使得相关事件通过互联网产生无限放大的效果。通过对敏感信息的研究和掌握，能有效的防止舆论事情的发酵，有效化解人民内部矛盾，有效制止平台负面新闻的进一步放大。运用技术及内控手段自动地对网络敏感信息进行整理和分析，能够有效、全面、迅速的建立敏感信息管理机制。通过实时对网络敏感信息的掌握，能够及时了解社会舆论的动向，能够有效引导社会舆论的发展，及时采取相应的措施，防止事态朝恶性方向扩大和变化。&nbsp;
        &nbsp;<br />美滋来的敏感信息管理规范主要由：敏感信息采集、敏感信息应用、敏感信息反馈和信息同步四部分组成，这四部分独立、交叉、重叠、循环存在，互相协同把控杜绝美滋来敏感信息的产生。美滋来将搭建“敏感信息管理规范”，根据互联网的发展势态和平台发展动向，汇集互联网信息管理方面中出现的问题，提出解决思路，全面分析和设计该规范的目标和原则。提升美滋来的餐饮品质，与餐饮商户一同推动外卖行业良性发展。<br /><a
          data-v-9f21bbfe=""
          >附则</a
        ><br /><a data-v-9f21bbfe="">一、规范变更</a
        ><br />美滋来有权对本规范内容进行修改、补充或更新，并在该规范生效前通过美滋来商户后台管理中心、美滋来网站公告等方式予以公告，上述公告一经发布即视为已经单独通知到每一家使用美滋来服务的商户；若商户在本规范内容修改、补充或更新公告后继续使用美滋来提供的服务，即视为商户同意遵守修改、补充或更新的规范。<br /><a
          data-v-9f21bbfe=""
          >二、规范效力</a
        ><br />本规范作为商户与美滋来所签署协议的附件，与协议具有相同法律效力。商户违反本规范的，按照本规范、双方协议及其他美滋来管理规范进行处罚。<br /><a
          data-v-9f21bbfe=""
          >三、无规定处理</a
        ><br />适用本规范的所有对象应遵守国家法律、行政法规、部门规章、地方法规等规范性文件。对任何涉嫌违反国家法律、行政法规、部门规章、地方法规等规范性文件的行为，本规范已有规定的，适用于本规范。本规范尚无规定的，美滋来有权依法处理。<br /><a
          data-v-9f21bbfe=""
          >四、溯及力</a
        ><br />发生在本规范生效之日前的行为，适用当时的规范进行处理；发生在本规范生效之日后的，适用本规范。<br /><a
          data-v-9f21bbfe=""
          >五、生效</a
        ><br /><br />本规范最新修订日期为2023年1月1日，自发布之日起7日后生效。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
